module.exports = __webpack_public_path__ + "img/cumple.a743c422.gif";